import { getInstanceByDom } from 'echarts';
import { useEffect } from 'react';
import { debug } from 'zf-web-infra';
import type { UseOptionParams } from './types';
import 'echarts-wordcloud';
import type { ChartsProps } from '../types';

/**
 * 设置Charts的属性
 * @param params
 */
export function useChartsOption(params: UseOptionParams, events: ChartsProps['events'] = []): void {
  debug.common('useChartsOption');

  useEffect(() => {
    if (params.node.current == null) {
      return;
    }
    const chart = getInstanceByDom(params.node.current);
    if (chart != null) {
      debug.common('set charts option');
      chart.setOption(params.option, params.settings);
      for (const event of events) {
        chart.on(event.type, event.handler);
      }
    }
    return (): void => {
      if (chart != null) {
        for (const event of events) {
          chart.off(event.type, event.handler);
        }
      }
    };
  }, [params, events]);
}

